<template>
  <div class="producer-register">
    <div class="page-head">
      <el-page-header @back="goBack" content="创作者注册"></el-page-header>
    </div>
    <el-steps :active="active" finish-status="success">
      <el-step title="类型选择"></el-step>
      <el-step title="基本资料"></el-step>
      <el-step title="实名认证"></el-step>
      <el-step title="系统审核"></el-step>
    </el-steps>
    <div class="step-wrap">
      <div v-show="active === 0" class="step-zero">
        <el-form size="small" label-width="120px">
          <el-form-item label="类型：">
            <template>
              <el-radio v-model="type" label="1">个人</el-radio>
              <el-radio v-model="type" label="2">公司</el-radio>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <StepOne ref="stepOne" v-show="active == 1" :type="type" />
      <StepTwo ref="stepTwo" v-show="active == 2" :type="type" />
      <StepThree ref="stepThree" v-show="active == 3" :type="type" />
      <div v-show="active == 3" class="contract">
        <div class="title">《凯伊莱文艺术联盟平台入驻服务协议》</div>
        <iframe class="content" :src="type == 1 ? protocolPerson : protocolCompany"></iframe>
        <el-button type="primary" size="mini" class="contract-btn" @click="agree" :disabled="checked || time !== 0">
          {{ btnText }}
        </el-button>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="prev">上一步</el-button>
      <el-button v-if="active == 3" type="success" @click="next">完成</el-button>
      <el-button v-else type="primary" @click="next">下一步</el-button>
    </div>
    <el-dialog
      title="认领提醒"
      :visible.sync="claimDialogVisible"
      :show-close="false"
      width="400px"
      :close-on-click-modal="false"
      center> 
      <span>系统检测到您的手机号码已经存在，是否需要认领该账户</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="claimCancel">取 消</el-button>
        <el-button type="primary" @click="claimConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { countryList } from '../../lib/constObj.js'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import API from '../../lib/API'
export default {
  name: 'producer-register',
  components: {
    StepOne,
    StepTwo,
    StepThree
  },
  data() {
    return {
      countryList,
      active: 0,
      checked: false,
      type: '1',
      companyName: '',
      claimDialogVisible: false,
      btnText: '我已阅读并同意签署（20s）',
      timer: null,
      time: 20,
      protocolPerson: 'https://manager-api-dev.anneleven.cn/protocol/person.html',
      protocolCompany: 'https://manager-api-dev.anneleven.cn/protocol/company.html ',
    }
  },
  mounted() {},
  methods: {
    agree() {
      this.checked = true
      this.btnText = '已阅读并同意签署'
    },
    claimCancel() {
      this.$router.back()
      this.claimDialogVisible = false
    },
    claimConfirm() {
      this.active += 1
      this.claimDialogVisible = false
    },
    claim(telephone) {
      new API(this).POST({
        url: '/author/checkAuthorExist',
        params: {
          telephone
        },
        cb: res => {
          if (res) {
            this.claimDialogVisible = true
          } else {
            this.active += 1
          }
        }
      });
    },
    prev() {
      if (this.active === 0) return
      this.active -= 1
    },
    next() {
      let { formDataOne } = this.$refs.stepOne.getFormData()
      if (this.active === 0) {
        this.active += 1
      } else if (this.active === 1) {
        this.$refs.stepOne.getValidate().then(() => {
          console.log('检验通过')
          if (this.$refs.stepOne.codeSuccess) {
            this.claim(formDataOne.telephone)
          } else {
            this.$message.error('请输入正确的验证码')
          }
        }).catch((err) => {
          console.log('第一步校验不通过')
          console.log(err)
        })
      } else if (this.active === 2) {
        this.$refs.stepTwo.getValidate().then(() => {
          this.active += 1
          if (this.time === 20) {
            this.contractCountdown()
          }
        }).catch(() => {
          console.log('第二步校验不通过')
        })
      } else {
        if (!this.checked) {
          return this.$message.error('请阅读并勾选协议')
        }
        this.$refs.stepThree.getValidate().then(() => {
          if (this.checked) {
            this.confirm()
          } else {
            this.$message.error('请您阅读并同意签署合同')
          }
        }).catch(() => {
          console.log('第三步校验不通过')
        })
      }
    },
    contractCountdown () {
      this.timer = setInterval(() => {
        this.time -= 1
        this.btnText = `我已阅读并同意签署（${this.time}s）`
        if (this.time === 0) {
          this.btnText = `我已阅读并同意签署`
          clearInterval(this.timer)
        }
      }, 1000)
    },
    confirm() {
      let { formDataOne } = this.$refs.stepOne.getFormData()
      let { formDataTwo } = this.$refs.stepTwo.getFormData()
      let { formDataThree } = this.$refs.stepThree.getFormData()
      let params = {}
      if (this.type == 1) {
        params = {
          ...formDataOne,
          ...formDataTwo,
          ...formDataThree
        }
      } else {
        params = {
          ...formDataOne,
          ...formDataTwo,
          ...formDataThree
        }
      }
      let url = this.type == 1 ? '/author/registerSelfAuthor' : '/author/registerCompanyAuthor'
      new API(this).POST({
        url,
        params,
        cb: res => {
          this.$alert('恭喜您注册成功！请等待我们的审核，审核过程中可以登陆并修改你的个人信息。', '注册成功', {
            confirmButtonText: '确定',
            callback: action => {
              this.goBack();
            }
          });
        }
      });
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.producer-register {
  padding: 20px;
  width: 700px;
  margin: 0 auto;
  .page-head {
    padding: 20px 0;
    margin-bottom: 20px;
  }
  /deep/ .el-input {
    width: 250px !important;
  }
  .step-wrap {
    width: 600px;
    margin: 50px auto;
  }
  .btn-group {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
  .checkbox-wrap {
    display: flex;
    align-items: center;
  }
  .contract {
    width: 100%;
    border: 1px solid #ccc;
    position: relative;
    padding:10px 0 50px;
    .content {
      overflow-y: auto;
      height:300px;
      border: none;
      width: 100%;
    }
    .title {
      text-align: center;
      padding: 5px 0;
    }
    .contract-btn {
      width:50%;
      position:absolute;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/producerRegister/ProducerRegister.vue